import { Button, Stack, Typography } from '@mui/material'
import { UseFormSetValue, UseFormWatch } from 'react-hook-form'

import { MagazinePageDirection } from '@/clients/utoniq-core/schema'
import { CreateItemProps } from '@/components/pages/ConsoleItemCreate/template/ItemCreateForm'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type PageDirectionInputCellProps = {
  watch: UseFormWatch<CreateItemProps>
  setValue: UseFormSetValue<CreateItemProps>
}
export const PageDirectionInputCell: Cell<PageDirectionInputCellProps> = ({
  watch,
  setValue,
}) => {
  const { t } = useTranslation('consoleItemCreate')
  const pageDirection = watch('metadata.magazine.pageDirection')
  const options = [
    { value: MagazinePageDirection.Left, label: t('left') },
    { value: MagazinePageDirection.Right, label: t('right') },
  ]
  return (
    <CellFrame sx={{ pb: 7 }}>
      <Typography variant="h5">{t('pageDirectionLabel')}</Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ pt: 2 }}
      ></Typography>
      <Stack direction="row" spacing={2} sx={{ py: 2 }}>
        {options.map((option, index) => (
          <Button
            key={index}
            variant={pageDirection === option.value ? 'contained' : 'outlined'}
            onClick={() => {
              setValue(
                'metadata.magazine.pageDirection',
                option.value as never,
                { shouldDirty: true }
              )
            }}
          >
            {option.label}
          </Button>
        ))}
      </Stack>
    </CellFrame>
  )
}
